import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import useLoadStatus from "../../../hooks/useLoadStatus/useLoadStatus";
import TextPill from "../TextPill/TextPill";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";

export default function LoadStatusPill({ value, darkTheme, large }) {
  const { currentStatus } = useLoadStatus(value, darkTheme);

  if (!currentStatus) return null;

  const { name, shortName, backgroundColor } = currentStatus;

  return (
    <StyledTooltip title={name}>
      <Box>
        <TextPill
          value={shortName}
          backgroundColor={backgroundColor}
          width={large ? "40px" : "20px"}
          borderRadius="2px"
          padding={large ? "0 1px" : "2px 1px"}
          variant={large ? "subhead1" : "label1"}
          textShadow={large}
        />
      </Box>
    </StyledTooltip>
  );
}

LoadStatusPill.propTypes = {
  value: PropTypes.string,
  darkTheme: PropTypes.bool,
  large: PropTypes.bool
};